import { GroupListModule } from './group-list/group-list.module';
import { GroupMembersModule } from './group-members/group-members.module';
import { GroupsComponent } from './groups.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    component: GroupsComponent,
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
      { path: 'list', loadChildren: () => GroupListModule },
    ],
  },
  { path: 'group-members', loadChildren: () => GroupMembersModule },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GroupsRoutingModule {}
